import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import RemoteConfigService from "services/RemoteConfigService";
import RemoteConfigContext from "./RemoteConfigContext";

interface RemoteConfigProviderProps {
  children?: React.ReactNode;
}

function RemoteConfigProvider(props: RemoteConfigProviderProps) {
  const [configStore, setConfigStore] = useState<{ [id: string]: boolean | undefined }>({
    HUB_ENABLE_VIDEO_PLAYBACK: false,
    ENABLE_AI_BULK_UPLOAD_V2_UI: false,
    HUB_ENABLE_1RM_BULK_UPLOAD: false,
    HUB_ENABLE_PROGRAM_IMPORT: false,
    HUB_ENABLE_AI_PERFORMANCE_SUMMARY: false,
  });
  const [queryParams] = useSearchParams();
  const queryParamsRef = useRef(queryParams);

  const getKeyValue = useCallback(async (key: string) => {
    let value = typeof queryParamsRef.current.get(key) === "string";

    if (!value) {
      value = await RemoteConfigService.getBooleanValue(key);
    }

    setConfigStore((prev) => ({ ...prev, [key]: Boolean(value) }));
  }, []);

  useEffect(() => {
    getKeyValue("HUB_ENABLE_VIDEO_PLAYBACK");
    getKeyValue("ENABLE_AI_BULK_UPLOAD_V2_UI");
    getKeyValue("HUB_ENABLE_1RM_BULK_UPLOAD");
    getKeyValue("HUB_ENABLE_PROGRAM_IMPORT");
    getKeyValue("HUB_ENABLE_AI_PERFORMANCE_SUMMARY");
  }, [getKeyValue]);

  const getConfigValue = useCallback(
    (key: string) => {
      const keyValue = configStore[key];
      return Boolean(keyValue);
    },
    [configStore]
  );

  return <RemoteConfigContext.Provider value={getConfigValue}>{props.children}</RemoteConfigContext.Provider>;
}

export default RemoteConfigProvider;
